const React = require('react');
const formatNum = require("mn-utils/formatNum");
const map = require('mn-utils/map');

const WrapperWithLoading = require('../../../../dumb/WrapperWithLoading/B');
const {apiGetMerchantStatistic} = require('../../../../../api/merchant/statistic');
const withState = require('../../../../../utils/withState');

const StatisticsItem = require('./StatisticsItem');

module.exports = withState((setState, self, onMount) => {
  const currencyCode = 'EUR';

  self.state = {
    loading: true,
  };

  onMount(() => {
    apiGetMerchantStatistic().then((res) => {
      const {
        pending_invoices = {},
        volumes_monthly = {},
        volumes_overall = {},
      } = res.finance || {};

      setState({
        invoices: pending_invoices[currencyCode].amount,
        monthlyVolumes: volumes_monthly[currencyCode].amount,
        overallVolumes: volumes_overall[currencyCode].amount,
        loading: false,
      });
    });
  });

  const formAmountString = (amount) => `${self.state.loading ? '120 000' : formatNum(amount)} ${currencyCode}`;

  return (state) => {
    const {
      invoices,
      monthlyVolumes,
      overallVolumes,
      loading,
    } = state;
    const items = [
      {
        title: 'Monthly transacted volume',
        value: formAmountString(monthlyVolumes),
        isTransparent: true,
      },
      {
        title: 'Pending Invoice',
        value: formAmountString(invoices),
      },
      {
        title: 'Overall Transacted volume',
        value: formAmountString(overallVolumes),
      },
    ];

    return (
      <WrapperWithLoading
        loading={loading}
      >
        <div className="layoutRow fxwWrap mt-20 mh-60 mh0@m">
          {map(items, (props, i ) => (
            <div key={i} className="w50% mt20 ph35 w@m ph0@m">
              <StatisticsItem {...props} />
            </div>
          ))}
        </div>
      </WrapperWithLoading>
    );
  };
});
